// src/data/programBonuses.js

const programBonuses = [
  {
    slug: "digital-marketing-mentorship-program",
    hasBonuses: false,
    heading: "",
    description: "",
    bonuses: [],
  },
  {
    slug: "performance-marketing-mentorship-program",
    hasBonuses: false,
    heading: "",
    description: "",
    bonuses: [],
  },
  {
    slug: "ui-ux-design-mentorship-program",
    hasBonuses: true,
    heading: "Exclusive bonuses waiting for you!",
    description:
      "Exclusive bonuses available to the first 50 enrollees only. Secure your spot now!",
    bonuses: [
      {
        id: 1,
        title: "Bonus 1",
        description:
          "Early Bird Access : Bonus - LinkedIn Mastery Self Paced Cohort",
      },
      {
        id: 2,
        title: "Bonus 2",
        description:
          "For Premium Users UI Design - Self Paced Generative AI For Designers (On-demand)",
      },
      {
        id: 3,
        title: "Bonus 3",
        description: "For Elite Users : All of the above and GS Perks",
      },
      {
        id: 4,
        title: "Bonus 4",
        description:
          "For Elite Users : All of the GS Perks, Numreous AI, Simplified AI, Supergrow AI, PLSFIX PPT Slides, AI Agents",
      },
    ],
  },
  {
    slug: "product-management-mentorship-program",
    hasBonuses: false,
    heading: "",
    description: "",
    bonuses: [],
  },
  {
    slug: "management-consulting-mentorship-program",
    hasBonuses: true,
    heading: "Exclusive bonus waiting for you!",
    description:
      "Exclusive bonus available to the first 50 enrollees only. Secure your spot now!",
    bonuses: [
      {
        id: 1,
        title: "Bonus 1",
        description:
          "Early Bird Access : Consulting Case Interview Preparation - Self Paced Course",
      },
    ],
  },
  {
    slug: "workshops/chatgpt-workshop",
    hasBonuses: true,
    heading: "Exclusive bonus waiting for you!",
    description:
      "Exclusive bonus available to the first 50 enrollees only. Secure your spot now!",
    bonuses: [
      {
        id: 1,
        title: "Bonus 1",
        description: "List of Gold-Standard and Hidden Prompts for GPT16",
      },
      {
        id: 2,
        title: "Bonus 2",
        description:
          "Copy-Paste Template To Using All in one AI tools like Simplified.com",
      },
      {
        id: 3,
        title: "Bonus 3",
        description:
          "Step by Step Method of Coding a Website with 0 prior knowledge in tech",
      },
      {
        id: 4,
        title: "Bonus 4",
        description:
          "Creating AI generated personas that provide you support of 10 humans using Synthesia",
      },
    ],
  },
  {
    slug: "workshops/linkedin-growth",
    hasBonuses: true,
    heading: "Exclusive bonus waiting for you!",
    description:
      "Exclusive bonus available to the first 50 enrollees only. Secure your spot now!",
    bonuses: [
      {
        id: 1,
        title: "Bonus 1",
        description:
          "Find your Objective & TG: Steal your competitors’ leads and customers using growth hacking.",
      },
      {
        id: 2,
        title: "Bonus 2",
        description:
          "Profile Optimisation: Will help you rank your profile on the LinkedIn search and generate you inbound leads like clockwork.",
      },
      {
        id: 3,
        title: "Bonus 3",
        description:
          "Connection Loop: Strategy to get accepted by top CXO's on LinkedIn.",
      },
      {
        id: 4,
        title: "Bonus 4",
        description:
          "Content Magic: The exact blueprint to create and post content on LinkedIn from starter to pro",
      },
      {
        id: 5,
        title: "Bonus 5",
        description:
          "The Outbound Game: Nurture connections by engaging with them before you send them your first message, resulting in skyrocketed conversions",
      },
    ],
  },
  {
    slug: "workshops/ai-for-consultants",
    hasBonuses: true,
    heading: "Exclusive bonus waiting for you!",
    description:
      "Exclusive bonus available to the first 50 enrollees only. Secure your spot now!",
    bonuses: [
      {
        id: 1,
        title: "Bonus 1",
        description:
          "Mastering GPT 4 for Consulting (Worth ₹1250): Exclusive Gold-Standard Consulting Prompts",
      },
      {
        id: 2,
        title: "Bonus 2",
        description:
          "Consulting Resumes Made Easy (Worth ₹1250): A Copy-Paste Industry-Approved  Consulting Resume Template",
      },
      {
        id: 3,
        title: "Bonus 3",
        description:
          "Business Case Study Bank (Worth ₹1250): Go-To Resource for Strategic Insights for Consultants",
      },
      {
        id: 4,
        title: "Bonus 4",
        description:
          "Supercharge Your Consulting Efficiency (Worth ₹1250): Repository of AI Tools for Research, Analysis, and Presentation",
      },
    ],
  },
  {
    slug: "workshops/product-management",
    hasBonuses: true,
    heading: "Exclusive bonus waiting for you!",
    description:
      "Exclusive bonus available to the first 50 enrollees only. Secure your spot now!",
    bonuses: [
      {
        id: 1,
        title: "Bonus 1",
        description: "Lifetime Access to our PM Discord Community",
      },
      {
        id: 2,
        title: "Bonus 2",
        description: "Expert-Crafted Competency Matrix",
      },
      {
        id: 3,
        title: "Bonus 3",
        description: "Additional Hand-Picked Learning Resources",
      },
    ],
  },
];

export default programBonuses;
